import GenericStore from '../classes/generic-store';
import { UserSearchesApi } from '../api/user-searches-api';

import { OpportunitiesStore } from './opportunities-store';
import { UserOpportunityFiltersStore } from './user-opportunity-filters-store';

class EditSavedFiltersStoreClass extends GenericStore {
  save(filterConfig) {
    return this.clearState(
      UserSearchesApi.createUserSearch({
        alertActive: false,
        name: filterConfig.name,
        search: this.formatFilters(filterConfig.filters),
        type: 'opportunity',
      }).then(async data => {
        UserOpportunityFiltersStore.load();
        await UserSearchesApi.refreshUserSearches('opportunity');
      })
    );
  }

  formatFilters(filters) {
    const { salesCloseDateStart, salesCloseDateEnd, ...updatedFilters } =
      filters;

    const salesCloseDate = {};
    if (filters.salesCloseDateStart) {
      salesCloseDate.start = salesCloseDateStart;
    }

    if (filters.salesCloseDateEnd) {
      salesCloseDate.end = salesCloseDateEnd;
    }

    if (salesCloseDate.start || salesCloseDate.end) {
      return {
        ...filters,
        salesCloseDate,
      };
    }

    return {
      ...filters,
    };
  }

  getDataShape() {
    return OpportunitiesStore.getMetaConfigShape();
  }
}

export const EditSavedOpportunityFilterStore = new EditSavedFiltersStoreClass();
